'use client'

import Header from '@/components/header'
import { ArrowLeft } from 'lucide-react'
import { useRouter } from 'next/navigation'

export default function Page() {
  const router = useRouter()
  return (
    <>
      <Header />

      <main className="min-h-screen bg-linear-to-br from-primary/5 via-background to-secondary/5 relative overflow-hidden">
        {/* 背景装饰 */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl animate-pulse-slow" />
          <div
            className="absolute bottom-20 right-1/4 w-96 h-96 bg-secondary/5 rounded-full blur-3xl animate-pulse-slow"
            style={{ animationDelay: '2s' }}
          />
        </div>

        {/* 内容区域 */}
        <div className="relative max-w-7xl mx-auto px-4 py-12">
          {/* 返回按钮 - 固定在左上角 */}
          <button
            onClick={() => router.push('/light')}
            className="group top24 left24 z-40 flex items-center gap-2 px-4 py-3 rounded-2xl bg-card/80 backdrop-blur-xl border-2 border-border hover:border-primary shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 animate-fade-in"
          >
            <div className="relative">
              <div className="absolute inset-0 bg-primary/20 rounded-full blur-md scale-0 group-hover:scale-150 transition-transform duration-500" />
              <ArrowLeft className="relative w-5 h-5 text-primary group-hover:text-primary transition-all duration-300 group-hover:-translate-x-1" />
            </div>
            <span className="text-sm font-medium text-foreground group-hover:text-primary transition-colors duration-300">
              返回
            </span>
          </button>
        </div>
      </main>
    </>
  )
}
